/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface DeleteEditorialCompanyDiscount$Params {
  companyId: number;
  discountId: number;
}

export function deleteEditorialCompanyDiscount(http: HttpClient, rootUrl: string, params: DeleteEditorialCompanyDiscount$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, deleteEditorialCompanyDiscount.PATH, 'delete');
  if (params) {
    rb.path('companyId', params.companyId, {});
    rb.path('discountId', params.discountId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

deleteEditorialCompanyDiscount.PATH = '/api/editorial/companies/{companyId}/discounts/{discountId}';
